<template>
  <div class="container header-wrap">
    <div class="header flex-row-center">
      <div class="flex-row-center-center header-left">
        <div class="logo flex-row-center-center">
          <img
            src="../assets/images/logo-img.png"
            style="
              width: 48px;
              height: 48px;
              margin-right: 10px;
              border-radius: 0 0 50% 50%;
            "
            alt=""
          />
          <a
            href="http://www.ju-kun.com/"
            target="_black"
            style="line-height: 0"
            ><img src="../assets/images/logo.png" style="width: 118px" alt="" />
            <!-- <div style="font-size:9px;color:#A6C8DD">公司地址：上海市杨浦区纪念路8号(邮编:200434)</div> -->
          </a>
        </div>
      </div>
      <div class="flex header-center" @click="goHome">
        <span class="header-center-title">巨鲲云监测平台</span>
      </div>
      <div class="header-right flex-row-center-center" @click="showBox">
        <div style="margin-right: 10px">
          <div style="font-size: 20px; color: var(--c-primary); margin-bottom: 6px">
            {{ timeStr }}
          </div>
          <div style="font-size: 9px; color: var(--c-text-muted)">
            上海市杨浦区纪念路8号科技园6号楼
          </div>
        </div>
        <div class="box flex-row">
          <div class="email" style="width: 28px; height: 28px" @click="goHome">
            <img src="../assets/images/home.png" alt="" />
          </div>
          <div class="email" @click="showMessage">
            <div class="tag" v-show="messageNum">
              {{ messageNum }}
            </div>
            <img src="../assets/images/email-icon.png" alt="" />
          </div>
          <div
            class="setting"
            style="margin-right: 20px"
            @click.stop="showSetting(!settingShow)"
          >
            <img src="../assets/images/setting-icon.png" alt="" />
            <el-collapse-transition>
              <div v-show="settingShow" class="setting-box" @click.stop>
                <div @click="showPassword(true, $event)">修改密码</div>
                <div class="skin-panel">
                  <div class="skin-panel-title">外观皮肤</div>
                  <button
                    v-for="item in themeList"
                    :key="item.id"
                    type="button"
                    :class="['skin-item', { active: currentTheme === item.id }]"
                    @click="changeTheme(item.id, $event)"
                  >
                    <span class="skin-swatch">
                      <i :style="{ background: item.swatch[0] }"></i>
                      <i :style="{ background: item.swatch[1] }"></i>
                      <i :style="{ background: item.swatch[2] }"></i>
                    </span>
                    {{ item.name }}
                  </button>
                </div>
                <div @click="loginOut">退出账号</div>
              </div>
            </el-collapse-transition>
          </div>
          <div class="setting" @click="changeFull">
            <img src="../assets/images/full-icon.png" alt="" v-if="!isFull" />
            <img src="../assets/images/full-no-icon.png" alt="" v-if="isFull" />
          </div>
        </div>
      </div>
      <el-collapse-transition>
        <div v-show="messageShow" class="message-box">
          <div v-for="item in messageList" :key="item.id">
            <div
              class="flex-row message-item"
              @click="checkMessage(item)"
              v-if="item.messageStatus == 'unread'"
            >
              <i class="el-icon-close" @click="readMessage(item, $event)"></i>
              <div class="circle"></div>

              <div class="flex flex-row-center">
                <div>
                  <span style="color: #000113; font-size: 17px">{{
                    item.projectName
                  }}</span>

                  <span
                    style="color: #404040; font-size: 14px"
                    v-show="item.status == 'red'"
                    >出现红色预警</span
                  >
                  <span
                    style="color: #404040; font-size: 14px"
                    v-show="item.status == 'yellow'"
                    >出现黄色预警</span
                  >
                  <span
                    style="color: #404040; font-size: 14px"
                    v-show="item.status == 'orange'"
                    >出现橙色预警</span
                  >
                  <!-- <span style="color:#404040;font-size:14px" v-show="item.status == 'normal'">出现红色预警</span> -->
                  <span
                    style="color: #404040; font-size: 14px"
                    v-show="item.status == 'offline'"
                    >出现离线情况</span
                  >
                </div>
                <div class="time" style="color: var(--c-accent); font-size: 14px">
                  {{ formatMessageTime(item.createTime) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-collapse-transition>
      <el-collapse-transition>
        <div v-show="passwordShow" class="password-box">
          <div class="login-content">
            <div class="close" @click="passwordShow = false">
              <img src="../assets/images/close.png" alt="" />
            </div>
            <div
              class="login-title"
              style="margin-top: 15px; margin-bottom: 15px"
            >
              修改密码
            </div>
            <div class="user-input">
              <input type="text" v-model="username" placeholder="输入账号" />
              <img src="../assets/images/user-icon.png" alt="" />
            </div>
            <div class="user-input">
              <input
                type="password"
                v-model="password"
                placeholder="输入密码"
              />
              <img src="../assets/images/lock-icon.png" alt="" />
            </div>
            <div class="user-input">
              <input
                type="password"
                v-model="newPassword"
                placeholder="输入新密码"
              />
              <img src="../assets/images/lock-icon.png" alt="" />
            </div>
            <div class="user-input">
              <input
                type="password"
                v-model="newPassword2"
                placeholder="确认新密码"
              />
              <img src="../assets/images/lock-icon.png" alt="" />
            </div>
            <div
              class="login-btn"
              @click="changePassword"
              style="margin-top: 20px"
            >
              确认修改
            </div>
          </div>
        </div>
      </el-collapse-transition>
    </div>
  </div>
</template>

<script>
import center from "../service/center.js";
import { THEMES, applyTheme, getTheme } from "../service/theme-service";
import { logoutPlatformSession } from "../service/platform-token-bridge";
export default {
  name: "app-header",
  data() {
    return {
      messageNum: 0,
      messageTimer: null,
      messageList: [],
      timeStr: "",
      messageShow: false,
      username: "",
      password: "",
      newPassword: "",
      newPassword2: "",
      passwordShow: false,
      settingShow: false,
      isFull: false,
      themeList: THEMES,
      currentTheme: getTheme(),
    };
  },
  mounted() {
    const currentUser = this.storage.getUser();
    if (currentUser) this.username = currentUser.data.mobilePhone;
    var now = new Date().getTime();
    this.timeStr = this.time.getDate(new Date().getTime(), 3);

    setTimeout(() => {
      now = now + 60000;
      this.timeStr = this.time.getDate(now, 3);

      setInterval(() => {
        now = now + 60000;
        this.timeStr = this.time.getDate(now, 3);
      }, 60000);
    }, now % 60000);
    // Header 可能出现在会话刚切换的瞬间；没有本地 JWT 时不发送
    // 依赖用户身份的请求，避免把初始化过程误报为登录失效。
    if (currentUser && currentUser.token) {
      this.getMessage();
      this.getMessageNum();
      this.messageTimer = setInterval(() => {
        this.getMessageNum();
        if (this.messageShow) this.getMessage();
      }, 30000);
    }
  },
  beforeDestroy() {
    clearInterval(this.messageTimer);
  },
  methods: {
    formatMessageTime(value) {
      if (value === null || value === undefined || String(value).trim() === "") {
        return "时间未知";
      }

      const raw = String(value).trim();
      // 后端消息时间可能是毫秒时间戳，也可能是 MySQL 返回的
      // "yyyy-MM-dd HH:mm:ss"。后者不能直接 Number()，否则会渲染为 NaN。
      const mysqlDate = raw.match(
        /^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2})(?::(\d{2}))?)?$/
      );
      if (mysqlDate) {
        const [, year, month, day, hour = "00", minute = "00"] = mysqlDate;
        return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")} ${String(hour).padStart(2, "0")}:${minute}`;
      }

      const numericValue = Number(raw);
      // Spring Boot 升级后，java.util.Date 常被序列化成 ISO-8601，例如
      // 2026-08-28T14:30:00.000+08:00；它不是数字时间戳，交由 Date.parse 解析。
      const timestamp = Number.isFinite(numericValue)
        ? (Math.abs(numericValue) < 100000000000 ? numericValue * 1000 : numericValue)
        : Date.parse(raw);
      if (Number.isNaN(timestamp)) {
        return "时间未知";
      }
      // 兼容秒级、毫秒级及 ISO-8601 时间，统一按东八区显示。
      const date = new Date(timestamp);
      if (Number.isNaN(date.getTime())) {
        return "时间未知";
      }
      const parts = new Intl.DateTimeFormat("sv-SE", {
        timeZone: "Asia/Shanghai",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hourCycle: "h23",
      }).formatToParts(date).reduce((result, part) => {
        result[part.type] = part.value;
        return result;
      }, {});
      return `${parts.year}-${parts.month}-${parts.day} ${parts.hour}:${parts.minute}`;
    },
    goHome(e) {
      // this.$router.push({path:'/project',query:{id:this.project.id}})
      e.stopPropagation();
      center.$emit("origin", "");

      this.$router.push({
        path: "/index",
      });
    },
    changeFull() {
      var isFull = !!(
        document.webkitIsFullScreen ||
        document.mozFullScreen ||
        document.msFullscreenElement ||
        document.fullscreenElement
      ); //!document.webkitIsFullScreen都为true。因此用!!
      this.isFull = !isFull;
      if (isFull == false) {
        this.fullScreen();
      } else {
        this.exitFullscreen();
      }
    },
    fullScreen() {
      var element = document.documentElement;
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen();
      }
    },

    exitFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    },
    showSetting(bool) {
      this.settingShow = bool;
      if (bool) {
        this.messageShow = false;
      }
    },
    changeTheme(id, e) {
      e.stopPropagation();
      this.currentTheme = applyTheme(id);
    },
    showPassword(bool, e) {
      e.stopPropagation();

      this.passwordShow = bool;
      if (bool) {
        this.settingShow = false;
      }
    },
    changePassword() {
      if (
        !this.username ||
        !this.password ||
        !this.newPassword ||
        !this.newPassword2
      ) {
        this.$message({
          message: "请输入完整信息",
          type: "warning",
        });
        return;
      }
      if (this.newPassword !== this.newPassword2) {
        this.$message({
          message: "两次新密码不相同",
          type: "warning",
        });
      }
      this.http.resource
        .put("/user", {
          mobilePhone: this.username,
          newPassword: md5(this.newPassword),
          oldPassword: md5(this.password),
        })
        .then((res) => {
          if (!res.errCode) {
            this.$message({
              message: "密码修改成功",
              type: "error",
            });
          } else {
            this.$message({
              message: res.errMsg,
              type: "error",
            });
          }
        });
    },
    showMessage() {
      if (this.messageNum || this.messageShow) {
        this.messageShow = !this.messageShow;
        if (this.messageShow) {
          this.settingShow = false;
          this.getMessage();
          this.getMessageNum();
        }
      } else {
        this.$message({
          message: "当前没有消息",
        });
      }
    },
    showBox() {
      this.showBool = !this.showBool;
    },
    getMessage() {
      this.http.resource.get("/message-page").then((res) => {
        this.messageList = !res.errCode && Array.isArray(res.data) ? res.data : [];
      }).catch(() => { this.messageList = []; });
    },
    getMessageNum() {
      this.http.resource.get("/message-count").then((res) => {
        this.messageNum = !res.errCode ? Number(res.data) || 0 : 0;
      }).catch(() => { this.messageNum = 0; this.messageList = []; });
    },
    async loginOut() {
      try {
        await logoutPlatformSession();
      } catch (error) {
        // 即使中台暂时不可达，也允许用户结束本地会话。
      } finally {
        this.storage.clearSession();
        this.$router.push({ name: "Login" });
      }
    },
    readMessage(item, e) {
      e.stopPropagation();
      this.http.resource
        .put("/message", {
          id: item.id,
          messageStatus: "read",
        })
        .then((res) => {
          if (!res.errCode) {
            item.messageStatus = "read";
            this.getMessageNum();
          } else {
            this.$message({
              message: res.errMsg,
              type: "error",
            });
          }
        });
    },
    checkMessage(item) {
      this.http.resource
        .put("/message", {
          id: item.id,
          messageStatus: "read",
        })
        .then((res) => {
          if (!res.errCode) {
            item.messageStatus = "read";
            this.getMessageNum();
          } else {
            this.$message({
              message: res.errMsg,
              type: "error",
            });
          }
        });
      this.$router.push({
        path: "/project",
        query: {
          id: item.projectId,
        },
      });
    },
  },
  // watch: {
  //   passwordShow (value) {
  //     if (value) {
  //       this.messageShow = false
  //       this.settingShow = false
  //     }
  //   },
  //   messageShow (value) {
  //     if (value) {
  //       this.passwordShow = false
  //       this.settingShow = false
  //     }
  //   },
  //   settingShow (value) {

  //     if (value) {
  //       this.messageShow = false
  //     }
  //   }
  // },
};
</script>
<style  scoped>
.header-wrap {
  background: rgba(2, 7, 58, 0.85);
  position: relative;
  z-index: 50;
}
.header {
  height: 66px;
  /* width: 1400px; */
  margin: 0 auto;
}
.container {
  width: 100%;
}
.header-left {
  background: url("../assets/images/header-left.png") no-repeat;
  background-position: 0 -5px;
  background-size: 100% 100%;
}
.header-right {
  background: url("../assets/images/header-right.png") no-repeat;
  background-position: 0 -5px;
  background-size: 100% 100%;
  padding-left: 25px;
}
.header-left,
.logo {
  width: 350px;
  height: 100%;
  justify-content: start !important;
}
.header-center {
  height: 100%;
  cursor: pointer;
  /* line-height: 70px; */
  font-size: 40px;
  letter-spacing: 6px;
  text-align: center;
  color: var(--c-text);
  position: relative;
  isolation: isolate;
  overflow: hidden;
  background: none;

  /* margin: 0 20px; */
  display: flex;
  justify-content: center;
  align-items: center;
}
.header-center::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  pointer-events: none;
  background: url("../assets/images/header-center.png") no-repeat;
  background-size: 100% 100%;
  filter: hue-rotate(var(--theme-banner-hue)) saturate(var(--theme-banner-sat));
}
.header-center-title {
  position: relative;
  z-index: 1;
}
.header-right {
  width: 405px;
  height: 100%;
}
.box {
}
.box .email {
  width: 25px;
  height: 25px;
  position: relative;
  margin-right: 20px;
  cursor: pointer;
}
.box .setting {
  width: 25px;
  height: 25px;
  position: relative;
  cursor: pointer;
  overflow: visible;
}
.tag {
  position: absolute;
  right: -5px;
  min-width: 14px;
  height: 14px;
  border-radius: 7px;
  text-align: center;
  line-height: 12px;
  color: #fff;
  background-color: #ff0000;
  font-size: 12px;
  padding: 0 3px;
}
.box img {
  width: 100%;
  height: 100%;
}

.message-box {
  position: absolute;
  top: 68px;
  right: 80px;
  width: 435px;
  padding: 0 20px;
  background: #fff;
  z-index: 999;
}
.message-box .message-item {
  height: 44px;
  border-bottom: 1px dashed #dedede;
  cursor: pointer;
}
.el-icon-close {
  display: none;
}
.message-item:hover .el-icon-close {
  display: block;
}
.el-icon-close:hover {
  font-size: 20px;
  color: var(--c-link);
}
.message-box .message-item:last-of-type {
  border-bottom: none;
}
.circle {
  width: 10px;
  height: 10px;
  background-color: #f51b1b;
  border-radius: 50%;
  margin-right: 18px;
}
.password-box {
  position: absolute;
  top: 180px;
  z-index: 50;
  left: 50%;
  transform: translateX(-50%);
  /* width: 600px; */
  /* height: 600px; */
  padding: 20px 100px 40px;
  background: #fff;
  background: url("../assets/images/index-right.png") no-repeat;
  background-size: 100% 100%;
}
.close {
  position: absolute;
  width: 50px;
  height: 50px;
  right: 20px;
  top: 10px;
  cursor: pointer;
  padding: 10px;
}
.close img {
  width: 100%;
  height: 100%;
}
.login-title {
  color: #ffffff;
  font-size: 21px;
  margin: 55px auto 30px;
  text-align: center;
}

.user-input {
  width: 264px;
  height: 32px;
  border: 1px solid var(--c-input-border);
  line-height: 30px;
  color: var(--c-link);
  position: relative;
  margin: 25px auto 0;
  padding: 0 45px;
}

.user-input input {
  padding: 0;
  border: none;
  background-color: transparent;
  width: 100%;
  color: var(--c-link);
}

.user-input input:focus {
  border: none;
  outline: none;
}

.user-input img {
  width: 18px;
  height: 23px;
  position: absolute;
  left: 8px;
  top: 4px;
}

.login-option {
  width: 264px;
  margin: 15px auto 0;
  color: #ffffff;
  font-size: 12px;
}

.login-option {
  cursor: pointer;
}

.login-btn {
  margin: 35px auto 0;
  background-color: var(--c-btn);
  color: #ffffff;
  height: 32px;
  width: 264px;
  line-height: 32px;
  text-align: center;
  cursor: pointer;
}

.setting-box {
  position: absolute;
  top: 32px;
  left: auto;
  right: -48px;
  transform: none;
  width: 176px;
  padding: 8px;
  background: var(--c-panel-solid);
  border: 1px solid var(--c-border-2);
  z-index: 999;
}
.setting-box > div {
  line-height: 40px;
  color: var(--c-primary-2);
  text-align: center;
  font-size: 15px;
  cursor: pointer;
}
.setting-box > div:hover {
  color: #fff;
  background-color: var(--c-btn-hover);
}
.skin-panel {
  padding: 6px 4px 10px;
  border-top: 1px solid var(--c-border);
  border-bottom: 1px solid var(--c-border);
  line-height: 1.2 !important;
  cursor: default !important;
}
.skin-panel:hover {
  color: var(--c-primary-2) !important;
  background: transparent !important;
}
.skin-panel-title {
  color: var(--c-text-muted);
  font-size: 12px;
  line-height: 28px;
  margin-bottom: 4px;
}
.skin-item {
  display: flex;
  align-items: center;
  width: 100%;
  height: 34px;
  margin-bottom: 4px;
  padding: 0 8px;
  color: var(--c-primary-2);
  border: 1px solid transparent;
  background: transparent;
  cursor: pointer;
  font-size: 13px;
}
.skin-item:last-child {
  margin-bottom: 0;
}
.skin-item:hover,
.skin-item.active {
  color: #fff;
  border-color: var(--c-border-3);
  background: var(--c-option-hover);
}
.skin-swatch {
  display: flex;
  width: 36px;
  margin-right: 8px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.18);
}
.skin-swatch i {
  flex: 1;
  height: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue